module.exports = __webpack_public_path__ + "img/arrow-white.1a118e9b.svg";